import { Box, SxProps, Typography } from "@mui/material"
import { DetailProps } from "./types"
import { useStyles } from "./styles"

const DetailArticle = (props: DetailProps) => {
    const styles = useStyles({ size: props.size })

    return (
        <Box {...props.boxProps} sx={{ ...styles.container, ...(props.boxProps?.sx ?? {}) as SxProps }}>
            <Typography sx={styles.title}>{props.title}</Typography>

            <Typography sx={styles.description}>{props.description}</Typography>

            <Typography sx={styles.footer}>{props.footer}</Typography>
        </Box>
    )
}

export { DetailArticle }
